module.exports = __webpack_public_path__ + "static/media/Quam-Icon-Search.5cda209f.svg";